import { createSvgIcon } from '@mui/material/utils'

const Line = createSvgIcon(
  <line
    x1="1.34888"
    y1="0.126953"
    x2="1.34888"
    y2="31.5805"
    stroke="#D8D9DC"
    strokeWidth="0.982922"
  />,
  'Line'
)

export default Line
